const BASE_API_URL = window.location.origin + "/api";

export default BASE_API_URL;